import { render, staticRenderFns } from "./hcmIndexChildDealer.vue?vue&type=template&id=66d6c13a"
import script from "./hcmIndexChildDealer.vue?vue&type=script&lang=js"
export * from "./hcmIndexChildDealer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports